import * as yup from 'yup';
import { containsNonAsciiLetters } from '@/utils/strings/strings';

export const healthContractBaseSchema = yup.object({
  memofeldBeratungsdokumentation: yup
    .string()
    .default('')
    .test(
      'isValidMemofeld',
      'Das Feld darf nur ASCII Zeichen enthalten.',
      (value) => !containsNonAsciiLetters(value),
    ),
});

export type HealthContractBase = yup.Asserts<typeof healthContractBaseSchema>;
